(function(){
    'use strict';

    angular
    .module('app')
    .controller('CaracteristicasController', CaracteristicasController)
 
    CaracteristicasController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function CaracteristicasController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.datos.caracteristicas = [];
        
        vm.fieldName = ""
        vm.sortableOptions = {
            handle: '.moverAc',
            placeholder:'app',
            stop: function(e, ui) { 
                //console.log("update");
                vm.update();
            },
          }; 

        vm.htmlDecode = function(input){
          var e = document.createElement('div');
          e.innerHTML = input;
          return e.childNodes[0].nodeValue;
        }

        vm.initVars = function(fieldName,value){
        	console.log(value);
            if(value!=""){
                value = vm.htmlDecode(value);
            }
            if(value!=""){
        	   value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
        	   value = JSON.parse(value);
        	   vm.datos = JSON.parse(value);
               //console.log(vm.datos);
            }
        	vm.fieldName = fieldName;
        }

        vm.update = function(){
			var json = angular.toJson(vm.datos);
			$timeout(function(){
				$('#'+vm.fieldName+"-jsonc").val(json).trigger("change");
			});
		}

        vm.addCaracteristica = function(){
        	var color = {};
        	color.titulo = "";
        	color.valor = "";
        	vm.datos.caracteristicas.push(color);
        	vm.update();
        }

        vm.borrarCp = function(index){
        	vm.datos.caracteristicas.splice(index, 1);
        	vm.update();
        }
    }


})();